import { Injectable } from "@angular/core";
import { AbstractService } from "../commons/abstract.service";
import { LeadCharts, PerDayChartData, Tracker } from "../models/tracker.model";
import { HttpClient } from "@angular/common/http";
import { SearchParams } from "../commons/abstract.types";
import { Observable } from "rxjs";
import { Pager } from "../commons/pager";

@Injectable({ providedIn: 'root' })
export class TrackerService extends AbstractService<Tracker> {
  getURLBase(): string {
    return '/tracker';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Tracker): void {
    delete obj?._id;
  }

  preUpdate(obj: Tracker): void {
  }

  getTrackingReport(page: number, perPage: number, search?: string, params?: Partial<SearchParams>): Observable<Pager<Tracker>> {
    const baseURL = `/tracking-report`;
    const pager = `${baseURL}?page=${page}&perPage=${perPage}`;

    const getSearchConfig = (search: string): string => {
      if (!!search) {
        return '&search=' + encodeURIComponent(search);
      } else {
        return '';
      }
    }
    const searching = `${pager}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        urling = `${urling}&${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

  getPieChartsData(params?: Partial<SearchParams>): Observable<LeadCharts> {
    let baseURL = `/dashboard/pie-chart`;
    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }

  getPerDayChartData(params?: Partial<SearchParams>): Observable<PerDayChartData[]> {
    let baseURL = `/dashboard/per-day-chart`;
    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }
}
